// Centralized translation dictionary for CRIAAA public site.
// Add new keys here, then use t('namespace.key') in components.

export type Lang = 'pt' | 'en';

export const dict = {
  pt: {
    common: {
      back_home: 'voltar ao início',
      back_to_criaaa: '← voltar para o criaaa',
      sending: 'ENVIANDO...',
      send: 'ENVIAR',
      confirm: 'CONFIRMAR',
      cancel: 'CANCELAR',
      copied: 'COPIADO',
      copy_link: 'COPIAR LINK',
      whatsapp: 'WHATSAPP',
      linkedin: 'LINKEDIN',
      or: 'OU',
      hide: 'OCULTAR',
      show: 'VER',
      loading: 'carregando...',
    },
    nav: {
      como: 'COMO FUNCIONA',
      planos: 'PLANOS',
      faq: 'FAQ',
      entrar: 'ENTRAR',
    },
    footer: {
      sobre: 'sobre',
      planos: 'planos',
      termos: 'termos',
      privacidade: 'privacidade',
      contato: 'contato',
    },
    bottomBar: {
      tagline: 'feito para quem cria.',
      placeholder: 'seu@email.com',
      submit: 'GARANTIR O MEU',
      done: 'na lista ✓',
      launch: 'lançamento em breve',
    },
    notFound: {
      title: '404',
      subtitle: 'Página não encontrada',
      cta: 'Voltar ao início',
    },
    sobre: {
      docTitle: 'Sobre — CRIAAA',
      metaDesc: 'Conheça a CRIAAA: plataforma de portfólio feita para quem cria no Brasil — endereço próprio, CMS simples e nada de código.',
      label: 'SOBRE',
      title: 'Sobre',
      highlight: 'A criaaa nasceu de uma percepção simples:\nquem cria merece um espaço à altura do que faz.\n\nNão um construtor de sites genérico.\nNão mais uma rede social.\nUm portfólio — de verdade.',
      block1Label: 'PARA QUEM CRIA',
      block1Text: 'Fotografia, ilustração, design, arte visual, motion. Qualquer pessoa que produz algo e precisa mostrar esse trabalho de forma profissional.',
      block2Label: 'COMO FUNCIONA',
      block2Text: 'Você escolhe seu endereço, organiza seus projetos e publica. O trabalho técnico fica com a gente — você foca no que importa: criar.',
      block3Label: 'FEITO NO BRASIL',
      block3Text: 'Em português, com preço em real, com suporte que entende o contexto de quem trabalha aqui.',
    },
    contato: {
      docTitle: 'Contato — CRIAAA',
      metaDesc: 'Fale com a CRIAAA sobre projetos personalizados, dúvidas da plataforma ou parcerias. Respondemos em até 48h úteis.',
      label: 'CONTATO',
      title: 'Contato',
      highlight: 'Tem algo em mente?\nFala com a gente.',
      block1Label: 'PROJETO PERSONALIZADO',
      block1Text: 'Precisa de algo além dos planos? A gente desenvolve sob medida.',
      block2Label: 'DÚVIDAS',
      block2Text: 'Sobre a plataforma, seu portfólio ou sua conta.',
      block3Label: 'PARCERIAS',
      block3Text: 'Comunidades, eventos, iniciativas criativas. Adoramos colaborar.',
      formLabel: 'MANDA UMA MENSAGEM',
      sentTitle: 'Mensagem recebida.\na gente responde em breve.',
      name: 'seu nome',
      email: 'seu@email.com',
      subject: 'no que posso te ajudar?',
      message: 'escreve à vontade.',
      error: 'Erro ao enviar. Tente novamente.',
      reply: 'respondemos em até 48h úteis.',
    },
    termos: {
      docTitle: 'Termos de Uso — CRIAAA',
      metaDesc: 'Termos de uso da CRIAAA: seu conteúdo é seu, suas responsabilidades, regras da conta e cancelamento.',
      label: 'TERMOS',
      title: 'Termos de uso',
      highlight: 'Ao usar a criaaa, você concorda com estes termos.\nSão simples — leia com calma.',
      blocks: [
        { label: 'SEU CONTEÚDO É SEU', text: 'A criaaa não reivindica direitos sobre nada que você publica. Suas imagens, textos e projetos pertencem a você.' },
        { label: 'SUA RESPONSABILIDADE', text: 'Você é responsável pelo conteúdo que publica. Conteúdo ilegal, ofensivo ou que viole direitos de terceiros será removido.' },
        { label: 'SUA CONTA', text: 'Mantenha sua senha segura. A criaaa não se responsabiliza por acessos não autorizados decorrentes de descuido com as credenciais.' },
        { label: 'CANCELAMENTO', text: 'Você pode encerrar sua conta a qualquer momento pelo painel de configurações. Seus dados serão removidos em até 30 dias.' },
        { label: 'ALTERAÇÕES', text: 'Podemos atualizar estes termos com aviso prévio por e-mail. O uso continuado da plataforma após o aviso implica concordância.' },
      ],
    },
    privacidade: {
      docTitle: 'Privacidade — CRIAAA',
      metaDesc: 'Política de privacidade da CRIAAA: o que coletamos, para que usamos e o que nunca fazemos com seus dados.',
      label: 'PRIVACIDADE',
      title: 'Privacidade',
      highlight: 'Não somos fãs de letras miúdas.\nO que coletamos, por que coletamos\ne o que nunca fazemos com seus dados —\ntudo aqui, sem enrolação.',
      blocks: [
        { label: 'O QUE COLETAMOS', text: 'E-mail, nome e conteúdo do portfólio. Nada além disso.' },
        { label: 'PARA QUE USAMOS', text: 'Para manter sua conta ativa, enviar comunicações relevantes sobre o serviço e melhorar a plataforma.' },
        { label: 'O QUE NÃO FAZEMOS', text: 'Não vendemos seus dados. Não compartilhamos com terceiros. Não usamos cookies de rastreamento.' },
        { label: 'SEUS DIREITOS', text: 'Você pode solicitar a exclusão completa da sua conta e de todos os seus dados a qualquer momento pelo formulário de contato.' },
        { label: 'COOKIES', text: 'Usamos apenas cookies essenciais para autenticação e funcionamento do site. Nada de rastreamento.' },
      ],
    },
    entrar: {
      docTitle: 'Entrar — CRIAAA',
      metaDesc: 'Entre na sua conta CRIAAA e acesse o CMS do seu portfólio.',
      heroTitle: 'Bom te ver por aqui.',
      benefits: [
        'Seu portfólio está esperando',
        'Acesse seu CMS',
        'Continue criando',
      ],
      title: 'Entrar',
      google: 'CONTINUAR COM GOOGLE',
      apple: 'CONTINUAR COM APPLE',
      email: 'seu@email.com',
      password: 'senha',
      submit: 'ENTRAR NA CONTA',
      submitting: 'ENTRANDO...',
      authError: 'e-mail ou senha não conferem.',
      noAccount: 'ainda não tem conta?',
      createAccount: 'criar a sua.',
      forgot: 'esqueceu a senha?',
      loggedOut: 'você saiu da sua conta.',
    },
    landing: {
      docTitle: 'CRIAAA — Seu Portfólio Sem Complicação',
      metaDesc: 'Portfólios profissionais para criativos. Seu endereço, do seu jeito. Sem código.',
      heroSub: 'Seu site, sem enrolação, sem código, com seu endereço.',
      waitlist: {
        submit: 'GARANTIR O MEU',
        count_suffix: 'criativos já na lista',
        modal: {
          profession_label: 'o que você cria',
          profession_placeholder: 'selecione...',
          professions: {
            design: 'Design',
            fotografia: 'Fotografia',
            ilustracao: 'Ilustração',
            motion: 'Motion',
            arquitetura: 'Arquitetura',
            '3d': '3D',
            outro: 'Outro',
          },
          portfolio_label: 'link do seu portfólio atual (opcional)',
          confirm: 'CONFIRMAR',
          skip: 'PULAR',
        },
        done: {
          title: 'Você entrou.',
          sub: 'Logo iremos te chamar. fique de olho no seu email.',
          invite_label: 'seu link de convite',
          invite_help: '5 convites aceitos = 1 mês grátis no seu plano',
          share_text: 'entrei na lista do CRIAAA — portfólios pra quem cria de verdade. entra pelo meu link:',
        },
      },
      ticker: ['Fotografia','Ilustração','Design','Direção de Arte','Motion','Branding','UX/UI','Moda','Arquitetura','Videografia','Animação','Tipografia','Editorial','Identidade Visual','Colagem','Gravura','Escultura Digital','3D'],
      provocacao: {
        lines: [
          'Instagram é vitrine pra influenciador.',
          'WhatsApp é pra grupo de família.',
          'Behance é o inimigo do recrutador.',
          'Seu trabalho merece destaque.',
        ],
        headline: 'Seu portfólio.\nSua identidade.\nSeu endereço.',
        body: 'Aqui você controla como o mundo vê o seu trabalho — não um algoritmo, não um template, não um feed compartilhado.',
      },
      como: {
        label: 'como funciona',
        steps: [
          { title: 'Crie sua conta', desc: 'Ecolha seu username, ele vira seu endereço. username.criaaa.com' },
          { title: 'Organize suas obras', desc: 'Arraste, ordene, agrupe em séries. imagens, vídeos e textos no mesmo lugar.' },
          { title: 'Compartilhe com o mundo', desc: 'Um link limpo, sem anúncios, sem distrações. só o que você criou.' },
        ],
      },
      layouts: {
        label: 'escolha o layout do seu portfólio',
        soon: 'EM BREVE',
        items: [
          { name: 'Cascata',    desc: 'Rolagem vertical, uma imagem por vez. contemplativo.' },
          { name: 'Panorama',   desc: 'Rolagem horizontal, filmstrip. sensação de exposição.' },
          { name: 'Dividida',   desc: 'Duas colunas lado a lado. ideal para contrastar séries.' },
          { name: 'Mosaico',    desc: 'Faixas de alturas variadas. hierarquia visual dinâmica.' },
          { name: 'Magazine',   desc: 'Colunas editoriais com hierarquia de tamanhos.' },
          { name: 'Lista',      desc: 'Obras em lista linear com título e descrição.' },
          { name: 'Grid Livre', desc: 'Posicionamento livre por arrasto. controle total.' },
          { name: 'Timeline',   desc: 'Obras ordenadas por data. ideal para mostrar evolução.' },
        ],
      },
      referral: {
        headline: 'CONVITES.\nUM MÊS GRÁTIS.',
        body: 'Indique cinco criativos. quando elas entrarem, você ganha um mês extra no seu plano.',
        how_label: 'como funciona',
        steps: [
          'Ao entrar, você recebe um link de convite para compartilhar.',
          'Cada amigo cadastrado pelo seu link conta como um convite.',
          'Com 5 convites aceitos e com conta criada, você ganha 1 mês grátis.',
          'Quanto mais você indica, mais tempo acumula.',
        ],
      },
      planos: {
        label: 'planos',
        intro_a: 'durante o acesso antecipado, todos os planos vêm com ',
        intro_b: '3 meses grátis e tudo liberado',
        intro_c: ' — exceto domínio personalizado.',
        cta_garantir: 'GARANTIR O MEU',
        cta_contato: 'ENTRAR EM CONTATO',
        free: {
          badge: 'FREE',
          name: 'Criativo',
          price: 'R$0',
          period: 'para sempre',
          features: ['5 galerias','10 imagens por galeria','username.criaaa.com','todos os layouts'],
        },
        pro: {
          badge: 'PRO — MAIS POPULAR',
          name: 'Profissional',
          period: 'por mês · cancela quando quiser',
          note: '3 meses grátis no acesso antecipado',
          features: ['galerias ilimitadas','imagens ilimitadas','username.criaaa.com','todos os layouts','aparência personalizada','domínio próprio incluso','vídeos ilimitados'],
        },
        premium: {
          badge: 'PREMIUM',
          name: 'Exclusivo',
          price: 'Sob consulta',
          period: 'setup + acompanhamento contínuo',
          features: ['diagnóstico e estratégia visual','criação completa do portfólio','identidade e aparência exclusiva','domínio e configurações técnicas','curadoria das obras','revisões por 30 dias','suporte direto'],
        },
      },
      faq: {
        label: 'perguntas frequentes',
        items: [
          { q: 'Quando o CRIAAA vai lançar?', a: 'Estamos em fase de acesso antecipado. Quem entrar na lista recebe um convite nos primeiros dias. a liberação acontece em lotes pequenos — não tem data fixa, tem fila.' },
          { q: 'O que está incluso no plano free?', a: '5 galerias, 10 imagens por galeria, seu subdomínio username.criaaa.com e todos os layouts de apresentação. para customizar aparência ou usar domínio próprio, você precisa do Pro.' },
          { q: 'Posso usar meu próprio domínio?', a: 'Sim, no plano Pro e Estúdio. Você aponta o domínio pelo painel e a gente cuida do resto — SSL, propagação e tudo mais.' },
          { q: 'Pra quem é o CRIAAA?', a: 'Foi feito para qualquer pesosoa criativa — ilustradores, designers, diretores de arte, artistas visuais, videographers, arquitetos, profissionais de moda. se você tem obras pra mostrar, é pra você.' },
          { q: 'Preciso saber programar pra usar?', a: 'Não. É tudo arrasta e solta. Você sobe as imagens, organiza como quiser, escolhe o layout e publica. Sem código, sem hospedagem, sem complicação.' },
          { q: 'Posso cancelar quando quiser?', a: 'Sim, sem fidelidade. Você cancela pelo painel a qualquer momento. O plano continua ativo até o fim do período pago.' },
        ],
      },
      closing: {
        headline: 'Você já cria.\nAgora apareça.',
        sub: 'Seu trabalho merece destaque.',
      },
    },
  },
  en: {
    common: {
      back_home: 'back home',
      back_to_criaaa: '← back to criaaa',
      sending: 'SENDING...',
      send: 'SEND',
      confirm: 'CONFIRM',
      cancel: 'CANCEL',
      copied: 'COPIED',
      copy_link: 'COPY LINK',
      whatsapp: 'WHATSAPP',
      linkedin: 'LINKEDIN',
      or: 'OR',
      hide: 'HIDE',
      show: 'SHOW',
      loading: 'loading...',
    },
    nav: {
      como: 'HOW IT WORKS',
      planos: 'PRICING',
      faq: 'FAQ',
      entrar: 'LOG IN',
    },
    footer: {
      sobre: 'about',
      planos: 'pricing',
      termos: 'terms',
      privacidade: 'privacy',
      contato: 'contact',
    },
    bottomBar: {
      tagline: 'made for those who create.',
      placeholder: 'you@email.com',
      submit: 'GET MINE',
      done: 'on the list ✓',
      launch: 'launching soon',
    },
    notFound: {
      title: '404',
      subtitle: 'Page not found',
      cta: 'Back home',
    },
    sobre: {
      docTitle: 'About — CRIAAA',
      metaDesc: 'Meet CRIAAA: a portfolio platform built for creatives — your own address, a simple CMS and no code.',
      label: 'ABOUT',
      title: 'About',
      highlight: 'criaaa was born from a simple insight:\nthose who create deserve a space worthy of their work.\n\nNot a generic site builder.\nNot another social network.\nA portfolio — a real one.',
      block1Label: "WHO IT'S FOR",
      block1Text: 'Photography, illustration, design, visual art, motion. Anyone producing work that needs to be shown professionally.',
      block2Label: 'HOW IT WORKS',
      block2Text: 'You pick your address, organize your projects and publish. We handle the technical work — you focus on what matters: creating.',
      block3Label: 'MADE IN BRAZIL',
      block3Text: 'Built locally with care, now available worldwide, with support that understands creative work.',
    },
    contato: {
      docTitle: 'Contact — CRIAAA',
      metaDesc: 'Talk to CRIAAA about custom projects, platform questions or partnerships. We reply within 48 business hours.',
      label: 'CONTACT',
      title: 'Contact',
      highlight: 'Got something in mind?\nTalk to us.',
      block1Label: 'CUSTOM PROJECT',
      block1Text: 'Need something beyond the plans? We build to order.',
      block2Label: 'QUESTIONS',
      block2Text: 'About the platform, your portfolio or your account.',
      block3Label: 'PARTNERSHIPS',
      block3Text: 'Communities, events, creative initiatives. We love to collaborate.',
      formLabel: 'SEND A MESSAGE',
      sentTitle: "Message received.\nwe'll reply soon.",
      name: 'your name',
      email: 'you@email.com',
      subject: 'how can we help?',
      message: 'write freely.',
      error: 'Failed to send. Please try again.',
      reply: 'we reply within 48 business hours.',
    },
    termos: {
      docTitle: 'Terms of Use — CRIAAA',
      metaDesc: 'CRIAAA terms of use: your content is yours, your responsibilities, account rules and cancellation.',
      label: 'TERMS',
      title: 'Terms of use',
      highlight: "By using criaaa, you agree to these terms.\nThey're simple — take your time.",
      blocks: [
        { label: 'YOUR CONTENT IS YOURS', text: 'criaaa claims no rights over anything you publish. Your images, text and projects belong to you.' },
        { label: 'YOUR RESPONSIBILITY', text: 'You are responsible for the content you publish. Illegal, offensive content or content that infringes third-party rights will be removed.' },
        { label: 'YOUR ACCOUNT', text: 'Keep your password safe. criaaa is not liable for unauthorized access resulting from credential mishandling.' },
        { label: 'CANCELLATION', text: 'You can close your account at any time from your settings panel. Your data will be removed within 30 days.' },
        { label: 'CHANGES', text: 'We may update these terms with prior notice by email. Continued use of the platform after the notice implies agreement.' },
      ],
    },
    privacidade: {
      docTitle: 'Privacy — CRIAAA',
      metaDesc: 'CRIAAA privacy policy: what we collect, what we use it for and what we never do with your data.',
      label: 'PRIVACY',
      title: 'Privacy',
      highlight: "We're not fans of fine print.\nWhat we collect, why we collect it\nand what we never do with your data —\nit's all here, no nonsense.",
      blocks: [
        { label: 'WHAT WE COLLECT', text: 'Email, name and portfolio content. Nothing more.' },
        { label: 'WHAT WE USE IT FOR', text: 'To keep your account active, send relevant service communications and improve the platform.' },
        { label: "WHAT WE DON'T DO", text: "We don't sell your data. We don't share with third parties. We don't use tracking cookies." },
        { label: 'YOUR RIGHTS', text: 'You can request complete deletion of your account and all your data at any time through the contact form.' },
        { label: 'COOKIES', text: 'We use only essential cookies for authentication and site operation. No tracking.' },
      ],
    },
    entrar: {
      docTitle: 'Sign in — CRIAAA',
      metaDesc: 'Sign in to your CRIAAA account and manage your portfolio CMS.',
      heroTitle: 'Good to see you here.',
      benefits: [
        'Your portfolio is waiting',
        'Access your CMS',
        'Keep creating',
      ],
      title: 'Sign in',
      google: 'CONTINUE WITH GOOGLE',
      apple: 'CONTINUE WITH APPLE',
      email: 'you@email.com',
      password: 'password',
      submit: 'SIGN IN',
      submitting: 'SIGNING IN...',
      authError: "email or password don't match.",
      noAccount: "don't have an account yet?",
      createAccount: 'create one.',
      forgot: 'forgot your password?',
      loggedOut: 'you signed out.',
    },
    landing: {
      docTitle: 'CRIAAA — Your Portfolio, No Fuss',
      metaDesc: 'Professional portfolios for creatives. Your address, your way. No code.',
      heroSub: 'Your site, no fuss, no code, with your own address.',
      waitlist: {
        submit: 'GET MINE',
        count_suffix: 'creatives already on the list',
        modal: {
          profession_label: 'what you create',
          profession_placeholder: 'select...',
          professions: {
            design: 'Design',
            fotografia: 'Photography',
            ilustracao: 'Illustration',
            motion: 'Motion',
            arquitetura: 'Architecture',
            '3d': '3D',
            outro: 'Other',
          },
          portfolio_label: 'link to your current portfolio (optional)',
          confirm: 'CONFIRM',
          skip: 'SKIP',
        },
        done: {
          title: "You're in.",
          sub: "We'll reach out soon. Keep an eye on your inbox.",
          invite_label: 'your invite link',
          invite_help: '5 accepted invites = 1 free month on your plan',
          share_text: "I just joined the CRIAAA waitlist — portfolios for people who really create. join through my link:",
        },
      },
      ticker: ['Photography','Illustration','Design','Art Direction','Motion','Branding','UX/UI','Fashion','Architecture','Videography','Animation','Typography','Editorial','Visual Identity','Collage','Engraving','Digital Sculpture','3D'],
      provocacao: {
        lines: [
          'Instagram is a shelf for influencers.',
          'WhatsApp is for family group chats.',
          "Behance is the recruiter's enemy.",
          'Your work deserves the spotlight.',
        ],
        headline: 'Your portfolio.\nYour identity.\nYour address.',
        body: 'Here you control how the world sees your work — no algorithm, no template, no shared feed.',
      },
      como: {
        label: 'how it works',
        steps: [
          { title: 'Create your account', desc: 'Pick your username, it becomes your address. username.criaaa.com' },
          { title: 'Organize your work', desc: 'Drag, reorder, group into series. Images, videos and text in one place.' },
          { title: 'Share with the world', desc: 'A clean link, no ads, no distractions. Just what you created.' },
        ],
      },
      layouts: {
        label: 'pick your portfolio layout',
        soon: 'SOON',
        items: [
          { name: 'Cascade',     desc: 'Vertical scroll, one image at a time. Contemplative.' },
          { name: 'Panorama',    desc: 'Horizontal scroll, filmstrip. Feels like an exhibition.' },
          { name: 'Split',       desc: 'Two columns side by side. Perfect to contrast series.' },
          { name: 'Mosaic',      desc: 'Bands of varying heights. Dynamic visual hierarchy.' },
          { name: 'Magazine',    desc: 'Editorial columns with size hierarchy.' },
          { name: 'List',        desc: 'Works in a linear list with title and description.' },
          { name: 'Free Grid',   desc: 'Free drag-and-drop placement. Full control.' },
          { name: 'Timeline',    desc: 'Works ordered by date. Great to show your evolution.' },
        ],
      },
      referral: {
        headline: 'INVITES.\nONE FREE MONTH.',
        body: 'Refer five creatives. When they join, you get an extra month on your plan.',
        how_label: 'how it works',
        steps: [
          'Once you join, you receive an invite link to share.',
          'Every friend who signs up through your link counts as an invite.',
          'With 5 accepted invites and active accounts, you earn 1 free month.',
          'The more you refer, the more time you accumulate.',
        ],
      },
      planos: {
        label: 'pricing',
        intro_a: 'during early access, every plan comes with ',
        intro_b: '3 free months and everything unlocked',
        intro_c: ' — except custom domain.',
        cta_garantir: 'GET MINE',
        cta_contato: 'GET IN TOUCH',
        free: {
          badge: 'FREE',
          name: 'Creative',
          price: '$0',
          period: 'forever',
          features: ['5 galleries','10 images per gallery','username.criaaa.com','all layouts'],
        },
        pro: {
          badge: 'PRO — MOST POPULAR',
          name: 'Professional',
          period: 'per month · cancel anytime',
          note: '3 free months during early access',
          features: ['unlimited galleries','unlimited images','username.criaaa.com','all layouts','custom appearance','custom domain included','unlimited videos'],
        },
        premium: {
          badge: 'PREMIUM',
          name: 'Exclusive',
          price: 'Contact us',
          period: 'setup + ongoing support',
          features: ['visual strategy & diagnosis','full portfolio creation','exclusive identity & appearance','domain & technical setup','works curation','30 days of revisions','direct support'],
        },
      },
      faq: {
        label: 'frequently asked',
        items: [
          { q: 'When will CRIAAA launch?', a: "We're in early access. Anyone on the list gets an invite within the first few days. Releases happen in small batches — no fixed date, just the queue." },
          { q: "What's included in the free plan?", a: '5 galleries, 10 images per gallery, your username.criaaa.com subdomain and all presentation layouts. To customize appearance or use a custom domain you need Pro.' },
          { q: 'Can I use my own domain?', a: 'Yes, on Pro and Studio plans. Point your domain from the panel and we handle the rest — SSL, propagation, everything.' },
          { q: 'Who is CRIAAA for?', a: 'For any creative — illustrators, designers, art directors, visual artists, videographers, architects, fashion professionals. If you have work to show, it’s for you.' },
          { q: 'Do I need to know how to code?', a: 'No. It’s all drag and drop. Upload images, organize them, pick a layout and publish. No code, no hosting, no fuss.' },
          { q: 'Can I cancel anytime?', a: 'Yes, no lock-in. Cancel from the panel anytime. Your plan stays active until the end of the paid period.' },
        ],
      },
      closing: {
        headline: 'You already create.\nNow show up.',
        sub: 'Your work deserves the spotlight.',
      },
    },
  },
} as const;

// Localized price for the single paid "Pro" plan.
export function priceFor(lang: Lang): { display: string; currency: 'brl' | 'usd'; amountCents: number; interval: 'month' } {
  return lang === 'en'
    ? { display: '$19.90', currency: 'usd', amountCents: 1990, interval: 'month' }
    : { display: 'R$49', currency: 'brl', amountCents: 4900, interval: 'month' };
}
